export default __webpack_public_path__ + "static/media/intimidatingshout.a79d4552.png";